module.exports = __webpack_public_path__ + "img/MaximilianVolkmann_140x140_rund.67161538.jpg";